import { createWebHistory, createRouter } from "vue-router";
import Login from '@/components/pages/Login'
import Registration from "@/components/pages/Registration"
import Welcome from '@/components/pages/Welcome'
import SelectUser from '@/components/pages/SelectUser'
import Layout from '@/components/layout/body.vue'
import Dashboard from '@/components/pages/Dashboard.vue'
import TestInClass from '@/components/pages/TestInClass'
import TestInClassStudent from '@/components/pages/TestInClassStudent'
import InClassTeacher from '@/components/pages/InClassTeacher'
import InClassStudent from "@/components/pages/InClassStudent"
import Classroom from "@/components/pages/Classroom.vue"

//axios
import axios from "axios"

//Vuex
import store from '../vuex'

//CSS
import "@/assets/css/main.css"
import "@/assets/css/InClass.css"

const router = createRouter({
  routes: [
    {
      path: '/',
      name: 'Layout',
      component: Layout,
      redirect: 'Welcome',
      children:[
        {
          path: 'dashboard',
          name: 'Dashboard',
          component: Dashboard
        },
        {
          path: '/welcome',
          name: 'Welcome',
          component: Welcome
        },
        {
          path: '/login',
          name: 'Login',
          component: Login
        },
        {
          path: '/registration',
          name: 'Registartion',
          component: Registration
        },
        {
          path: '/select_user',
          name: 'Select_user',
          component: SelectUser
        },
        {
          path: '/test_in_class_teacher',
          name: 'TestInClass',
          component: TestInClass
        },
        {
          path: '/test_in_class_student',
          name: 'TestInClassStudent',
          component: TestInClassStudent
        },
        {
          path: '/in_class_teacher',
          name: 'InClassTeacher',
          component: InClassTeacher
        },
        {
          path: '/in_class_student',
          name: 'InClassStudent',
          component: InClassStudent
        },
        {
          path: '/classroom',
          name: "Classroom",
          component: Classroom
        }
      ]
    },
    {
      path: '/logout',
      name: 'Logout',
      component: {
        render(c) {
            axios.get("/logout").
            finally(
              function(){
                store.commit("setLogin", false)
                window.location.href = "/login"
              }
            )
        }
      }
    }
  ],
  history: createWebHistory()
})

export default router
